export default __webpack_public_path__ + "static/media/Trident of Okeanos.dbc4944e.jpg";